import { config } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';
import {store} from "~/store";

export const getAppointmentsDetails = (appointmentType) => {
  const fittingTypes = store?.getState()?.appointment?.draft?.fittingTypes;
  const fittingTypesArray = fittingTypes ? Object.values(fittingTypes) : [];
  let appointmentDetails = {
    journey: config.services[services.CHILDREN_SHOE_FITTING.name]?.analyticsJourneyName || 'children\'s shoe fitting',
    shoeFit: fittingTypesArray.length ? fittingTypesArray.join('|') : '',
    numberOfChildren: fittingTypesArray.length,
    branchId: '',
  };
  if (appointmentType.id) {
    appointmentDetails = {
      ...appointmentDetails,
      ...window?.jlData?.page?.appointments
    }
  }
  return appointmentDetails;
};
